<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c20/guide01.png" alt="비대면진료 한시적 전면 허용 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c20/guide02.png" alt="비대면진료 한시적 전면 허용 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c20/guide03.png" alt="비대면진료 한시적 전면 허용 (다음 내용 참조)" />
        <div class="sr-only">
            <h2>보건의료 위기상황 대응에 따른 비대면진료 한시적 전면 허용</h2>
            <div>                 
                <p>정부 지침에 따라, 현재 진행중인 보건의료 위기상황을 관리하기 위해 <strong>비대면 진료 서비스가 한시적으로 전면 허용</strong>됩니다. 
                본 조치는 정부 방침에 따른 한시적 조치로 상황 변화에 따라 서비스 제공 범위가 조정될 수 있습니다.</p>
                <span>비대면진료 시범사업 지침 개정안 보건복지부 공고 제2024-134호 </span>
            </div>
            <div>
                <div>
                    <span>비대면진료 자격</span>
                    <h3>요일, 지역과 관계없이 비대면진료 이용 가능</h3>
                    <span>솔닥 제휴 병의원 운영시간 내 비대면진료를 이용할 수 있습니다.</span>
                </div>
                <div>
                    <p>평일, 휴일 및 위치에 무관하게 비대면진료를 이용할 수 있습니다.</p>
                    <span>* 본 조치는 정부 방침에 따른 한시적 조치로, 언제든 종료될 수 있습니다.</span>
                </div>
            </div>
            <h2>솔닥 비대면진료 이렇게 이용하세요</h2>
            <div>
                <div>
                    <span>솔닥 비대면진료 예약</span>
                    <h3>솔닥 앱을 통한 비대면진료 예약</h3>        
                    <ul>
                        <li>솔닥 앱에서 진료를 희망하는 증상과 병원 선택 후 비대면 진료를 예약하세요.</li>
                    </ul>
                </div>
                <div>
                    <span>약 처방 및 수령 안내1</span>
                    <h3>처방약은 가까운 약국에 방문하여 수령하세요</h3>
                    <ul>
                        <li>비대면진료 후 솔닥 앱에서 인근 약국을 선택하여 처방전을 전송하세요</li>
                        <li>약국에 방문하여 처방약을 수령하세요</li>
                    </ul>
                    <dl>
                        <dt>Q 보습제 MD 등 병원판매 의료기기는 어떻게 수령하나요?</dt>
                        <dd>A 병원판매 의료기기의 경우 기존과 같이 <strong>택배 배송이 가능합니다.</strong></dd>
                    </dl>
                </div>
                <div>
                    <span>약 처방 및 수령 안내2</span>
                    <h3>아래 의약품은 비대면 진료시 처방이 금지되어 있습니다.</h3>      
                    <ul>
                        <li>마약, 항정신성 의약품</li>
                        <li>오·남용 우려 의약품 (성기능 치료제 등)</li>
                        <li>사후피임약</li> 
                    </ul>
                </div>
            </div>
            <div>
                <h3>안전하고 편리한 비대면진료 솔닥이 함께하겠습니다.</h3>
                <p>솔닥은 정부의 지침을 엄격히 준수하여 모든 환자 분들이 편리하고 안전하게 비대면진료 서비스를 이용할 수 있도록 최선을 다하겠습니다.</p>
                <p>이번 한시적 조치가 종료될 때까지 솔닥은 여러분의 건강을 지키기 위해 노력하겠습니다.</p>
            </div>    
        </div>
    </div>
</template>

<script>
export default {
	name: "c20",
	methods: {}
};
</script>

<style scoped>
.contain {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
}
.imgs {
	width: 100%;
}
.contain .sr-only {
	position: absolute;
	left: -9999px;
	width: 1px;
	height: 1px;
	margin: 0 !important;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_view/contents/c20.vue